<template>
  <div class="page">
    <div class="group_1" >
      <div v-if="list.length>0">
      <div class="box_1" v-for="item in list" :key="item.id" >
        <div class="title">{{ item.cName }}</div>
        <div class="info">
          <div class="info_left">
            <img :src="item.cImage" alt="铜仁学院省级专业技术人员继续教育培训平台" v-if="item.cImage!=null&&item.cImage!=''"/>

            <img src="../../assets/new/xiaoBg.png" alt="铜仁学院省级专业技术人员继续教育培训平台" v-else/>
          </div>
          <div class="info_right">
            <div class="text_3">培训方式：{{ item.cMode=='01'?'在线': item.cMode=='02'?'面授':'混合' }}</div>
            <div class="text_3">学时：{{ item.cCredithour }}学时</div>
            <div class="text_4"><span class="text_5">¥</span>{{ Number(item.ordMoneySum).toFixed(2) || 0}}</div>
          </div>
        </div>
        <div class="box_2">
          <div class="text_6">购买时间：{{item.ordPayTime}}</div>
          <div class="text_7" @click="handleWatch(item)">立即学习</div>
        </div>
      </div>
      <div @click="loadMore" v-if="hasMore" class="load-more">点击加载更多</div>
        <div v-else class="no-more">没有更多数据了~</div>
    </div>

      <van-empty description="暂无课程" v-else/>
      <!-- <div @click="goto">去课程资源库</div> -->
    </div>
  </div>
</template>
<script>
import { toMyZYKCourseList } from '../../api/vip';

export default {
  components: {},
  data() {
    return {
      pageNum: 1,
      pageSize: 5,
      list: [],
      total: 0,
      hasMore: true ,
      isMember:'',//是否会员
    };
  },
  methods: {
    goto() {
      this.$router.push({
        path: '/resource'
      });
    },
    getViplist() {
      const param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize
      };
      toMyZYKCourseList(param).then(res => {
        this.isMember=res.data.isMember
        if (this.pageNum === 1) {
          this.list = res.data.rows;
        } else {
          this.list = [...this.list, ...res.data.rows];
        }
        this.total = res.data.total;
        this.hasMore = this.list.length < this.total;
      });
    },
    loadMore() {
      this.pageNum++;
      this.getViplist();
    },
      handleWatch(item) {
      console.log(item);
      this.$router.push({
        path: '/zykPlayer',
        query: {
          courseId: item.id,
          // classId: item.classId,
          courseWareId: item.cwId,
          courseName: item.cName
        }
      });
    },
  },
  created() {
    this.getViplist();
     this.$nextTick(() => {
      const scrollContainer = document.querySelector('.page');
      if (scrollContainer) {
        scrollContainer.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    });
  }
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.page {
  background-color: #f6f8fa;
  height: 100vh;
  overflow-y: scroll;
}
.load-more, .no-more {
  text-align: center;
  padding: 10px;
  font-size: 14px;
  color: #999;
}
.no-more {
  color: #666;
}
.group_1 {
  display: flex;
  flex-direction: column;
  padding: 10px 15px;
  .box_1 {
    // width: 345px;
    height: 205px;
    padding: 16px 15px;
    margin-bottom: 10px;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    .title {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 15px;
      width: 200px;
      color: #333333;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .info {
      display: flex;
      margin-top: 20px;
      .info_left {
        width: 110px;
        height: 88px;
        background: #d9d9d9;
        border-radius: 8px 8px 8px 8px;
        img {
          width: 110px;
          height: 88px;
          background: #d9d9d9;
          border-radius: 8px 8px 8px 8px;
        }
      }
      .info_right {
        margin-left: 12px;
        .text_3 {
          margin-top: 11px;
          width: 200px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 13px;
          color: #333333;
          margin-bottom: 6px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .text_4 {
          font-size: 17px;
          color: #ff2d31;
        }
        .text_5 {
          font-size: 12px;
          color: #ff2d31;
        }
      }
    }
  }
}
.box_2 {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  align-items: center;
  .text_6 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 13px;
    color: #999999;
  }
  .text_7 {
    width: 76px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    background: linear-gradient(97deg, #2a70f2 0%, #669cff 100%);
    border-radius: 16px 16px 16px 16px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 13px;
    color: #ffffff;
  }
}
</style>
